import { render } from "./settings-page-header.vue?vue&type=template&id=3a045a74&ts=true"
import script from "./settings-page-header.ts?vue&type=script&lang=ts"
export * from "./settings-page-header.ts?vue&type=script&lang=ts"

import "./settings-page-header.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__